module.exports = __webpack_public_path__ + "img/list_1_zh.91da6f20.png";